import { Link } from '@tanstack/react-router';
import { useTranslation } from '@/i18n';

interface StartModalProps {
  onStart: () => void;
}

export function StartModal({ onStart }: StartModalProps) {
  const { t } = useTranslation();

  return (
    <div className="modal-backdrop animate-fade-in p-2 sm:p-4">
      <div className="card p-4 sm:p-8 max-w-md w-full animate-scale-in max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] overflow-y-auto">
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <Link 
            to="/" 
            className="px-3 py-1.5 rounded-full bg-border-dark 
                       text-text-secondary hover:text-text-primary hover:bg-border-light
                       transition-colors text-sm font-medium"
          >
            {t.common.back}
          </Link>
          <div className="flex-1" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-text-primary text-center mb-1">
          {t.cabinetTransformer.title}
        </h2>
        <p className="text-ukonnx-green font-semibold text-center text-xs sm:text-sm tracking-wider mb-4 sm:mb-6">
          {t.cabinetTransformer.subtitle}
        </p>

        <p className="text-text-primary text-center text-sm sm:text-base mb-4 sm:mb-6">
          <strong>{t.cabinetTransformer.missionTitle}</strong>
          <br />
          <span className="text-text-secondary">
            {t.cabinetTransformer.missionText}
          </span>
        </p>

        <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
          <h3 className="text-ukonnx-green font-semibold text-xs sm:text-sm uppercase tracking-wider">
            {t.cabinetTransformer.howToPlay}
          </h3>

          <div className="flex items-center gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center 
                          bg-ukonnx-green/20 rounded-lg shrink-0">✅</span>
            <span className="text-text-secondary text-sm sm:text-base">
              {t.cabinetTransformer.inst1}
            </span>
          </div>

          <div className="flex items-center gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center 
                          bg-accent-red/20 rounded-lg shrink-0">❌</span>
            <span className="text-text-secondary text-sm sm:text-base">
              {t.cabinetTransformer.inst2}
            </span>
          </div>

          <div className="flex items-center gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center 
                          bg-accent-gold/20 rounded-lg shrink-0">✨</span>
            <span className="text-text-secondary text-sm sm:text-base">
              {t.cabinetTransformer.inst3}
            </span>
          </div>
        </div>

        <div className="bg-accent-gold/10 border border-accent-gold/30 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
          <h4 className="text-accent-gold font-semibold text-xs sm:text-sm mb-1 sm:mb-2">{t.cabinetTransformer.howToWin}</h4>
          <p className="text-text-secondary text-xs sm:text-sm">
            {t.cabinetTransformer.winText}
          </p>
        </div>

        <button onClick={onStart} className="btn-primary w-full text-base sm:text-lg py-3 sm:py-4">
          {t.cabinetTransformer.startBtn}
        </button>
      </div>
    </div>
  );
}
